<footer class=" bg-light" id="footer">
  <div class="container">
    <div class="row justify-content-center mb-3">
      <a class="" routerLink="">
        <img src="assets/img/logo_muted.svg" alt="phurshell">
      </a>
    </div>
  </div>
</footer>